// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .popover {\n    max-width: 400px;\n}\n#app .popover-content {\n    background-color: white !important;\n}\n@media print {\n#app .popover {\n        display: none !important;\n}\n}", ""]);
// Exports
module.exports = exports;
